import {css} from 'styled-components';
import {InputAnnotation, Theme} from '../types';

type Props = {
  theme: Theme
}

export const Input = css(({theme}: Props) => {
  const styles: InputAnnotation = {};

  if (theme.input?.borderColor) {
    styles.borderColor = theme.input.borderColor;
  }

  if (theme.input?.padding) {
    styles.padding = theme.input.padding;
  }

  if (theme.input?.background) {
    styles.background = theme.input.background;
  }

  if (theme.input?.height) {
    styles.height = theme.input.height;
  }

  return styles;
});
